module.exports = __webpack_public_path__ + "static/media/instagram.8a1f2572.svg";